<child-header title="Creating Subscriptions" (closeEvent)="close(false)"></child-header>
<mat-spinner
  *ngIf="loading"
  mode="indeterminate"
  class="circle"
  diameter="20"
  style="display: block; margin: 50px auto;"
  >
  </mat-spinner>
<div class="mat-dialog-body" *ngIf="!loading">
  <div mat-dialog-content>
    <div class="row">
      <span *ngIf="doneCreation"> Subscription created successfully ! </span>
      <mat-form-field [floatLabel]="'always'" *ngIf="!doneCreation">
        <input matInput class="lastNameValidate" [formControl]="displayName" placeholder="Subscritpion Display Name"
          required>
      </mat-form-field>
      <!-- <div *ngIf="!doneCreation">
        <div class="my-2">
          MPN : 
          <span class="red-bold">
            {{ mpn?.value == '' ? NoMPNText : mpn.value }}
          </span>
          <i
            style="margin: -10px 0 0 5px; position: absolute;"
            class="basic-icon edit-icon cursor-pointer"
            (click)="toggleMPNChange()"
          ></i>
        </div>
  
        <div class="row">
          <div class="col-12">
            <mat-form-field *ngIf="editMpn" class="full-width my-4" appearance="fill" style="padding-left: 0px;">
              <input
                type="text"
                placeholder="Change MPN"
                aria-label="Number"
                matInput
                integerOnly
                #trigger="matAutocompleteTrigger"
                [formControl]="mpn"
                [matAutocomplete]="auto"
              >
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option [value]="NoMPNText">
                  {{NoMPNText}}
                </mat-option>
                <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                  {{mpn}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      </div> -->

    </div>
  </div>
  <div mat-dialog-actions>
    <button *ngIf="!doneCreation" mat-button class="button button-red button-mid button-left" (click)="close(false)">Cancel</button>
    <button *ngIf="!doneCreation" [disabled]="displayName?.invalid" mat-button class="button button-red button-mid" (click)="confirm()">Confirm</button>
    <button *ngIf="doneCreation" mat-button class="button button-red button-mid" (click)="close(true)">OK</button>
  </div>
</div>